import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from '@env/environment';


export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ValidateCodeComponent),
  multi: true,
};


/**
 * 验证码
 */
@Component({
  selector: 'validate-code',
  templateUrl: './validate-code.component.html',
  providers: [EXE_COUNTER_VALUE_ACCESSOR],
  styles: [],
})
export class ValidateCodeComponent implements OnInit, ControlValueAccessor {

  imageUrl: string = environment.SERVER_URL + 'api/code/image/?';
  imageSrc: string;

  imageCode: string;
  propagateChange = (_: any) => {
  };

  constructor() {
  }

  ngOnInit() {
    this.getImage();
  }

  getImage() {
    this.imageSrc = this.imageUrl + new Date().getTime();
  }

  public refresh() {
    this.getImage();
  }

  onChange() {
    this.propagateChange(this.imageCode);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }


  writeValue(obj: any): void {
    this.imageCode = obj;
  }
}
